import {
  ProvinceSelectField,
  CitySelectField,
  DistrictSelectField,
  SubDistrictSelectField,
  InputField
} from 'components'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { Button } from 'reactstrap'
import LoaderButton from 'components/molecules/loader-button'
import StringUtil from 'utils/string-util'
import { useHistory } from 'react-router-dom'
import * as Yup from 'yup'

const propTypes = {
  handleSubmit : PropTypes.func.isRequired,
  address      : PropTypes.object,
  isSubmitting : PropTypes.bool
}

const validationSchema = Yup.object().shape({
  street_address : Yup.string().required('Cannot be blank'),
  province       : Yup.string().required('Cannot be blank'),
  city           : Yup.string().required('Cannot be blank'),
  district       : Yup.string().required('Cannot be blank'),
  sub_district   : Yup.string().required('Cannot be blank'),
  postal_code    : Yup.string().required('Cannot be blank')
})

/**
 * Print simple text label
 * @param {string} value
 */
/* eslint-disable react/prop-types */
const CurrentValue = ({ value }) => <span className="text-black-50">
  <span className="font-weight-bold">Current value: </span>
  <span className="font-italic">{ value || '-' }</span>
</span>

/**
 * Form to edit shipment address
 * @param {func} handleSubmit Handler for submitting the form
 * @param {object} address initial address
 * @param {boolean} isSubmitting
 */
const CustomerOrderShipmentAddressForm = ({
  handleSubmit,
  address,
  isSubmitting
}) => {
  const history = useHistory()

  const getProvinceValue = (formikBag, provinceKey) => {
    const keys                     = provinceKey.split('.')
    const { values: formikValues } = formikBag
    let newValues                  = formikValues
    keys.map((k) => newValues = newValues[ k ])
    return newValues
  }

  return (
    <Formik
      enableReinitialize={ true }
      initialValues={{
        street_address : address.street_address || '',
        province       : StringUtil.humanizeUpperCase(address.province),
        city           : StringUtil.humanizeUpperCase(address.city),
        district       : StringUtil.humanizeUpperCase(address.district),
        sub_district   : StringUtil.humanizeUpperCase(address.sub_district),
        postal_code    : address.postal_code || '',
        note           : address.note || ''
      }}
      onSubmit={ handleSubmit }
      validationSchema={ validationSchema }
    >
      {
        (formikBag) => (
          <>
            <Form>
              <InputField
                type='text'
                name='street_address'
                label='Jalan'
                required={ true }
                formText={ <CurrentValue value={ address.street_address } /> }
              />
              <ProvinceSelectField
                label='Provinsi'
                required={ true }
                valueType='name'
                formText={ <CurrentValue value={ address.province } /> }
              />
              <CitySelectField
                name='city'
                label='Kota'
                required={ true }
                provinceValue = { getProvinceValue(formikBag,'province') }
                valueType='name'
                formText={ <CurrentValue value={ address.city } /> }
              />
              <DistrictSelectField
                name='district'
                label='Kecamatan'
                required={ true }
                valueType='name'
                formikBag={ formikBag }
                formText={ <CurrentValue value={ address.district } /> }
              />
              <SubDistrictSelectField
                name='sub_district'
                label='Kelurahan'
                required={ true }
                valueType='name'
                formikBag={ formikBag }
                formText={ <CurrentValue value={ address.sub_district } /> }
              />
              <InputField
                type='text'
                name='postal_code'
                label='Kode Pos'
                required={ true }
                formText={ <CurrentValue value={ address.postal_code } /> }
              />
              <InputField
                type='text'
                name='note'
                label='Note'
                formText={ <CurrentValue value={ address.note } /> }
              />
              <Button
                color="danger"
                onClick={ () => history.goBack() }
              >
                Back
              </Button>
              <LoaderButton
                className='float-md-right'
                isLoading={ isSubmitting }
                block={ false }
                color='success'
                text="UPDATE"
                type='submit'
              />
            </Form>
          </>
        )
      }
    </Formik>
  )}


CustomerOrderShipmentAddressForm.propTypes = propTypes

export default CustomerOrderShipmentAddressForm